// extracted by mini-css-extract-plugin
export var testimonialCarousel = "styles-module--testimonialCarousel--i8Q49";
export var controls = "styles-module--controls--adgbb";
export var current = "styles-module--current--C-RUB";
export var disabled = "styles-module--disabled--vVXh1";
export var dot = "styles-module--dot--mS4xs";